/**
 * Zaman Portföyü'nün süre birimi: **dakika**. Hem toplantı süresi (sunucu hesaplar) hem uçuş süresi
 * (kullanıcı girer) tek sayı olarak taşınır; ekranda saat + dakikaya bölünür.
 *
 * Biçim tek yerde tutulur çünkü iki sekme de, hem tablo hem kart görünümü de aynı metni yazmak
 * zorundadır — kopyalansaydı biri "1 sa 5 dk", diğeri "65 dk" derdi.
 */

/** Dakikayı "S sa D dk" biçimine çevirir; tam saatte yalnız saat, bir saatin altında yalnız dakika. */
export function formatDuration(
  minutes: number | null | undefined,
  labels: { hour: string; minute: string },
): string {
  if (minutes == null || Number.isNaN(minutes) || minutes <= 0) return '-'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} ${labels.minute}`
  if (m === 0) return `${h} ${labels.hour}`
  return `${h} ${labels.hour} ${m} ${labels.minute}`
}

/** Saat + dakika alanlarını tek sayıya toplar (form → API). */
export function toMinutes(hours: number, minutes: number): number {
  return hours * 60 + minutes
}

/** Tek sayıyı saat + dakikaya böler (API → form). */
export function splitMinutes(total: number | null | undefined): { hours: number; minutes: number } {
  const value = total && total > 0 ? total : 0
  return { hours: Math.floor(value / 60), minutes: value % 60 }
}

/** Sunucunun `HH:mm:ss` döndürebildiği saat alanını ekranın beklediği `HH:mm`'e kırpar. */
export function shortTime(value: string | null | undefined): string {
  return value ? value.slice(0, 5) : ''
}
